import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
  CreateProductCardsDefectParams,
  ProductCardDefect,
  UpdateProductCardsDefectParams
} from "../types/product-card-defect.types";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../core/constants/base-url";
import {productCardsDefectsResourceType} from "../configs/product-card-defects-config";
import {RecordsDataRequestQueryParams} from "../../../../core/types/records-table.types";
import {jsonPathHeaders} from "../../../../core/models/http-headers";

@Injectable({
  providedIn: 'root'
})
export class ProductCardsDefectsApiService {
  private http: HttpClient = inject(HttpClient);
  private url: string = `${baseUrl}/${productCardsDefectsResourceType.path}`;

  public getProductCardsDefectsPages(queryParams: RecordsDataRequestQueryParams): Observable<Array<ProductCardDefect>> {
    return this.http.get<Array<ProductCardDefect>>(`${this.url}/p`, {
      params: queryParams
    });
  }

  public getProductCardsDefects(queryParams: RecordsDataRequestQueryParams): Observable<Array<ProductCardDefect>> {
    return this.http.get<Array<ProductCardDefect>>(`${this.url}/`, {
      params: queryParams
    });
  }

  public getProductCardDefect(id: number): Observable<ProductCardDefect> {
    return this.http.get<ProductCardDefect>(`${this.url}/${id}`);
  }

  public createProductCardsDefect({ productCardId, title }: CreateProductCardsDefectParams): Observable<ProductCardDefect> {
    return this.http.post<ProductCardDefect>(`${this.url}`, { title }, { params: { productCardId: productCardId } });
  }

  public updateProductCardsDefect({ id, value }: UpdateProductCardsDefectParams): Observable<ProductCardDefect> {
    const patchOperations = [{
      'op': 'add',
      'path': `/title`,
      'value': value !== undefined ? value : null
    }];

    return this.http.patch<ProductCardDefect>(`${this.url}/${id}`, patchOperations, {
      headers: jsonPathHeaders
    });
  }

  public deleteProductCardsDefect(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
